/**
 * clampSentence — truncate text at a sentence boundary (redesign item 3).
 * Never cuts mid-word; strips upstream "..." tails; falls back to a word
 * boundary + single ellipsis only when no usable sentence end exists.
 */
export function clampSentence(text, max = 320) {
  if (!text) return "";
  let t = String(text).trim().replace(/(\.{3,}|…+)$/g, "").trim();
  if (t.length > max) t = t.slice(0, max);
  if (/[.!?]["')\]]?$/.test(t)) return t;
  const m = t.match(/^[\s\S]*[.!?]["')\]]?(?=\s)/);
  if (m && m[0].length > 60) return m[0].trim();
  const lastSpace = t.lastIndexOf(" ");
  return (lastSpace > 60 ? t.slice(0, lastSpace) : t).replace(/[,;:]$/, "").trim() + "…";
}
